export function createInitialActions() {
    return {
        actions: [],
        isExecuted: false,
    };
}
export function addInitialAction(initialActions, action) {
    if (!initialActions || initialActions.isExecuted) {
        action();
    }
    else {
        initialActions.actions.push(action);
    }
}
export function executeInitialActions(initialActions) {
    if (initialActions && !initialActions.isExecuted) {
        // Use setTimeout to run after window.requestAnimationFrame() so that the execution time isn't counted in CTQ
        window.setTimeout(function () {
            // the array can be added with more values during the loop, so use for loop to handle all new added values
            for (var i = 0; i < initialActions.actions.length; i++) {
                initialActions.actions[i]();
            }
            initialActions.actions = [];
            initialActions.isExecuted = true;
        }, 0);
    }
}
//# sourceMappingURL=InitialActions.js.map